import {useIntl} from 'react-intl'
import {Column} from './types'
import {FC} from 'react'
import ColumnSearchInput from './ColumnSearchInput'
import clsx from 'clsx'

type Props = {
  columns: Column[]
  sortingField: string
  sortingOrder: 'asc' | 'desc'
  onSortingChange: (field: string) => void
  onInputChange: (col: Column, value: any) => void
  hasBulkActions?: boolean
  allSelected?: boolean
  toggleSelectedRows?: () => void
}

const TableHeader: FC<Props> = ({
  columns,
  sortingField,
  sortingOrder,
  onSortingChange,
  onInputChange,
  hasBulkActions,
  allSelected,
  toggleSelectedRows,
}) => {
  const intl = useIntl()

  if (columns.length < 1) return null

  return (
    <>
      <tr>
        {hasBulkActions && (
          <th>
            <div className='form-check form-check-sm form-check-custom form-check-solid'>
              <input
                className='form-check-input'
                type='checkbox'
                checked={allSelected}
                onChange={() => toggleSelectedRows?.()}
              />
            </div>
          </th>
        )}
        <td align='center'>{intl.$t({id: 'GENERAL.SR_NO'})}</td>
        {columns.map((column: Column, index: number) => !(typeof column.hide === 'function' ? column.hide() : column.hide) && (
          <th
            key={index}
            onClick={() => (column.sortable ? onSortingChange(column.field) : null)}
            className={clsx({
              'text-center': column.field === 'action',
              'cursor-pointer': column.sortable,
            })}
          >
            {column.name}
            {column.sortable && column.field === sortingField && (
              <i
                className={`fa ${sortingOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'} float-end`}
                aria-hidden='true'
                key={index}
              ></i>
            )}
          </th>
        ))}
      </tr>
      {columns.some(
        (column) =>
          (column?.searchBy || (Array.isArray(column.searchList) && column.searchList?.length > 0))
          && !(typeof column.hide === 'function' ? column.hide() : column.hide)
      ) && (
        <tr>
          {hasBulkActions && <th></th>}
          <th></th>
          {columns.map((column: Column, index: number) => (
            !(typeof column.hide === 'function' ? column.hide() : column.hide) && <th key={index} className='p-0'>
              <ColumnSearchInput column={column} onInputChange={onInputChange} />
            </th>
          ))}
        </tr>
      )}
    </>
  )
}

export default TableHeader
